module.exports = __webpack_public_path__ + "static/media/b2_p11_scout.ce4d5df8.mp3";